import React, { FC } from 'react'
import { SliderComponent } from '../components'
import SliderData from './data/slider.json'

const contactHref = '/contatti?utm_source_button=carplanner-slider'

const SliderContainer: FC = () => (
  <SliderComponent
    title={SliderData.title}
    image={SliderData.image}
    subtitle={SliderData.subtitle}
    boxes={SliderData.boxes}
    contactAction={SliderData.contact.action}
    contactHref = {contactHref}
  />
)

export default SliderContainer
